/**
 * Text fields inside the station screen (M6 P33): the game's input layer listens for keys on the window and cancels
 * bound keys (W, A, S, D…), which would stop them being typed. A field's keydown stops there, so typing reaches only
 * the field; Escape still goes through to close the screen.
 */
import type { KeyboardEvent } from 'react'

export function keepTyping(e: KeyboardEvent<HTMLInputElement>): void {
  if (e.key !== 'Escape') e.stopPropagation()
}
